import {
  Dialog,
  MuiThemeProvider,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import React from "react";
import {
  reviewsDialogColumns,
  reviewsDialogOptions,
} from "../utils/reviews-dialog-colums";
import MUIDataTable from "mui-datatables";
import { actionTableMuiTheme } from "../../table/table_styles";

const ReviewsDialog = ({ data, isOpen, setIsOpen }) => {
  const isDesktop = useMediaQuery("(min-width: 960px)");
  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      maxWidth="md"
      fullWidth
      id="interested_in_mindflow_dialog"
    >
      <div style={{ padding: "20px" }}>
        <Typography variant="h5" style={{ marginBottom: "20px" }}>
          Reviews
        </Typography>
        {data.length > 0 ? (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <Typography variant="h6" style={{ marginLeft: "auto" }}>
              Total: {data.length}
            </Typography>
            <MuiThemeProvider theme={actionTableMuiTheme()}>
              <MUIDataTable
                columns={reviewsDialogColumns}
                data={data}
                options={{
                  ...reviewsDialogOptions,
                  tableBodyMaxHeight: isDesktop ? "50em" : "357px",
                }}
              />
            </MuiThemeProvider>
          </div>
        ) : (
          <Typography variant="h6">
            There is no reviews in this school
          </Typography>
        )}
      </div>
    </Dialog>
  );
};

export default ReviewsDialog;
